<template>
  <div class="form_upload_admin">
    <a-upload
      list-type="picture"
      style="flex:1;width:50%;"
      :default-file-list="fileList"
    >
      <a-button class="w_294"><a-icon type="upload" />从本地上传</a-button>
    </a-upload>

    <a-popover trigger="click">
        <template slot="content">
            <a-input-search placeholder="www.mysite" @search="onSearch">
                <a-button slot="enterButton">确 定</a-button>
            </a-input-search>
        </template>
        <a-button class="fixed_btn w_294"><a-icon type="api" />粘贴文件链接</a-button>
    </a-popover>

  </div>
</template>

<script>
export default {
    data() {
        return {
            fileList: [],
        }
    },
    methods:{
        onSearch(){}
    }
}
</script>

<style lang="scss" scoped>
.form_upload_admin{
    position: relative;
    display: flex;
}
.fixed_btn{
    position: absolute;
    right: 0;
    top: 5px;
}
.w_294{
    width: 281px;
    background: #F0F3F8;
    border: none;
}
</style>